var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Button from "@widgets/button/button";
import React from "react";
export default function ButtonGroup({ alignment, buttons, is_grouped }) {
    return (React.createElement("div", { className: `ltg-button-group${alignment != 'left' ? ` align-${alignment}` : ''}${is_grouped ? ' ltg-button-group--no-gap' : ''}` }, buttons === null || buttons === void 0 ? void 0 : buttons.map((_a) => {
        var { _id } = _a, params = __rest(_a, ["_id"]);
        return (React.createElement(Button, Object.assign({ key: _id }, params)));
    })));
}
